module.exports = __webpack_public_path__ + "img/banner_3.83ffa12f.svg";